// src/services/pricingApi.js
import api from "./apiServices"; // Your existing configured axios instance

// --- LeadPricingCategorySettings ---
export const getCategoryPricingSettings = (categoryId) =>
  api.get(`/admin/lead-pricing/${categoryId}/settings/`);

export const createOrUpdateCategoryPricingSettings = (
  categoryId,
  settingsData
) => api.put(`/admin/lead-pricing/${categoryId}/settings/`, settingsData);

// --- PricingConditionDefinition ---
export const getPricingConditionDefinitions = (params) =>
  api.get("/admin/lead-pricing/condition-definitions/", { params }); // params: { skip, limit, active_only }

export const createPricingConditionDefinition = (data) =>
  api.post("/admin/lead-pricing/condition-definitions/", data);

export const getPricingConditionDefinitionById = (id) =>
  api.get(`/admin/lead-pricing/condition-definitions/${id}`);

export const updatePricingConditionDefinition = (id, data) =>
  api.put(`/admin/lead-pricing/condition-definitions/${id}`, data);

export const deletePricingConditionDefinition = (id) =>
  api.delete(`/admin/lead-pricing/condition-definitions/${id}`);

// --- LeadPricingRule ---
export const getPricingRulesForSetting = (settingId, params) =>
  api.get(`/admin/lead-pricing/category-pricing-settings/${settingId}/rules/`, {
    params,
  }); // params: { active_only }

export const createPricingRule = (settingId, ruleData, locale) =>
  api.post(
    `/admin/lead-pricing/category-pricing-settings/${settingId}/rules/`,
    ruleData, {
      params: { locale: locale },
    }
  );

export const getPricingRuleById = (settingId, ruleId) =>
  api.get(
    `/admin/lead-pricing/category-pricing-settings/${settingId}/rules/${ruleId}`
  );

export const updatePricingRule = (settingId, ruleId, ruleData, locale) =>
  api.put(
    `/admin/lead-pricing/category-pricing-settings/${settingId}/rules/${ruleId}`,
    ruleData, {
      params: { locale: locale },
    }
  );

export const deletePricingRule = (settingId, ruleId) =>
  api.delete(
    `/admin/lead-pricing/category-pricing-settings/${settingId}/rules/${ruleId}`
  );

// You can export all as a single object if you prefer:
// const pricingApi = {
//   getCategoryPricingSettings,
//   createOrUpdateCategoryPricingSettings,
//   getPricingConditionDefinitions,
//   // ... etc.
// };
// export default pricingApi;
